import React from "react";

/**
 * Read-only stats row at the bottom of UserModal (edit mode only).
 */
export function UserStats({ user }) {
    return (
        <div className="border-t border-zinc-800 pt-4 grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
            <Info label="Points fidélité" value={user.loyalty_points || 0} />
            <Info label="Code parrainage" value={user.referral_code || "—"} />
            {user.role === "sponsor" && <Info label="Sponsorings" value={user.sponsorships_count || 0} />}
            {user.role === "club" && <Info label="Annonces" value={user.clubs_count || 0} />}
        </div>
    );
}

function Info({ label, value }) {
    return (
        <div className="bg-zinc-900 border border-zinc-800 p-3">
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-bold">{label}</div>
            <div className="text-orange-500 font-bold">{value}</div>
        </div>
    );
}
